export { useConfig };
import { usePageContext } from '../usePageContext.js';
import { getPageContext } from 'vike/getPageContext';
import { applyHeadSettings } from '../../integration/applyHeadSettings.js';
function useConfig() {
    // Vike hook
    let pageContext = getPageContext();
    if (pageContext)
        return (config) => setPageContextConfigFromHook(config, pageContext);
    // Component
    pageContext = usePageContext();
    return (config) => {
        if (!('_headAlreadySet' in pageContext)) {
            setPageContextConfigFromHook(config, pageContext);
        }
        else {
            applyHead(config);
        }
    };
}
function setPageContextConfigFromHook(config, pageContext) {
    pageContext._configFromHook ?? (pageContext._configFromHook = {});
    Object.assign(pageContext._configFromHook, config);
}
function applyHead(config) {
    const { title, lang } = config;
    applyHeadSettings(title, lang);
}
